import { InquiriesState, InquiriesAction } from './inquiries.actions';
import * as Actions from './inquiries.actions';
import { ReqState } from '../../../../types';
import { InquiryStage } from '../../../../types/inquiries';
import { INQUIRY_PAGE_STAGES } from '../../../../constants/inquiries';


const initialState: InquiriesState = {
  stagePages: {}
};
INQUIRY_PAGE_STAGES.forEach(stageDefn => initialState.stagePages[stageDefn.slug] = 1);

function mergeStates(current: InquiriesState, incoming: InquiriesState = {}) {
  const stageInquiries = { ...current.stageInquiries, ...incoming.stageInquiries };
  const reqStates = { ...current.reqStates, ...incoming.reqStates };

  const copy = Object.assign({}, current, incoming, { stageInquiries, reqStates });
  return copy;
}

function updateStageReqState(state: InquiriesState, stage: InquiryStage, reqState: ReqState): InquiriesState {
  const reqStates = { ...state.reqStates }
  reqStates[stage] = reqState;

  return { ...state, reqStates };
}

export default function Inquiries(
  state: InquiriesState = initialState,
  action: InquiriesAction
) {
  switch (action.type) {
    case Actions.LOAD_ALL_STAGES:
      return mergeStates(state, action.payload);
    case Actions.LOAD_STAGE:
      return mergeStates(
        state,
        {
          reqStates: { [action.stageSlug]: ReqState.IN_PROGRESS },
          stagePages: { ...state.stagePages, [action.stageSlug]: 1 }
        },
      );
    case Actions.LOAD_MORE_FOR_STAGE:
      return mergeStates(
        state,
        {
          reqStates: { [action.stageSlug]: ReqState.IN_PROGRESS },
          stagePages: { ...state.stagePages, [action.stageSlug]: state.stagePages[action.stageSlug] + 1 }
        },
      );
    case Actions.STORE_STAGE:
      return Object.assign(
        {},
        mergeStates(state, Object.assign(
          {},
          updateStageReqState(action.payload, action.stageSlug, ReqState.SUCCESS)
        ))
      );
    case Actions.SELECT_STAGE:
      return Object.assign(
        {}, state,
        { inquiryDetailsVisible: false } as InquiriesState
      );

    case Actions.SEARCH:
      return mergeStates(state, {
        searchReqState: ReqState.IN_PROGRESS,
        filters: action.payload.filters || state.filters
      });
    case Actions.STORE_SEARCH:
      return mergeStates(state, {
        searchResults: action.payload.searchResults,
        searchReqState: ReqState.SUCCESS
      });

    case Actions.CLOSE_DETAILS:
      return mergeStates(state, { inquiryDetailsVisible: false });
    case Actions.SET_FILTER_VISIBILITY:
      return mergeStates(state, {
        filterCardVisible: action.payload.filterCardVisible,
        // Prevent the filter and detail cards from being open at the same time
        inquiryDetailsVisible: action.payload.filterCardVisible ? false : state.inquiryDetailsVisible
      });
    case Actions.TOGGLE_FILTER_VISIBILITY:
      return mergeStates(state, {
        filterCardVisible: !state.filterCardVisible,
        // Prevent the filter and detail cards from being open at the same time
        inquiryDetailsVisible: false
      });

    case Actions.SELECT_INQUIRY:
      return mergeStates(state, {
        selectedInquiry: action.payload.selectedInquiry,
        // Prevent the filter and detail cards from being open at the same time
        inquiryDetailsVisible: true,
        filterCardVisible: false
      });
    case Actions.LOAD_FTF:
      return mergeStates(state, { ftfReqState: ReqState.IN_PROGRESS });
    case Actions.LOAD_COMMENTS:
      return mergeStates(state, { commentsReqState: ReqState.IN_PROGRESS });
    case Actions.LOAD_SELECTED_PROPERTIES:
      return mergeStates(state, { selectedPropertiesReqState: ReqState.IN_PROGRESS });
    case Actions.LOAD_VIEWING_LISTS:
      return mergeStates(state, { viewingListsReqState: ReqState.IN_PROGRESS });
    case Actions.LOAD_OFFERS:
      return mergeStates(state, { offersReqState: ReqState.IN_PROGRESS });
    case Actions.LOAD_CONTRACTS:
      return mergeStates(state, { contractsReqState: ReqState.IN_PROGRESS });

      case Actions.LOAD_FTF_FAILED:
        return mergeStates(state, { ftfReqState: ReqState.FAILED });
      case Actions.LOAD_COMMENTS_FAILED:
        return mergeStates(state, { commentsReqState: ReqState.FAILED });
      case Actions.LOAD_SELECTED_PROPERTIES_FAILED:
        return mergeStates(state, { selectedPropertiesReqState: ReqState.FAILED });
      case Actions.LOAD_VIEWING_LISTS_FAILED:
        return mergeStates(state, { viewingListsReqState: ReqState.FAILED });
      case Actions.LOAD_OFFERS_FAILED:
        return mergeStates(state, { offersReqState: ReqState.FAILED });
      case Actions.LOAD_CONTRACTS_FAILED:
        return mergeStates(state, { contractsReqState: ReqState.FAILED });

    case Actions.STORE_FTF:
      return mergeStates(state, { ...action.payload, ftfReqState: ReqState.SUCCESS });
    case Actions.STORE_COMMENTS:
      return mergeStates(state, { ...action.payload, commentsReqState: ReqState.SUCCESS });
    case Actions.STORE_SELECTED_PROPERTIES:
      return mergeStates(state, { ...action.payload, selectedPropertiesReqState: ReqState.SUCCESS });
    case Actions.STORE_VIEWING_LISTS:
      return mergeStates(state, { ...action.payload, viewingListsReqState: ReqState.SUCCESS });
    case Actions.STORE_OFFERS:
      return mergeStates(state, { ...action.payload, offersReqState: ReqState.SUCCESS });
    case Actions.STORE_CONTRACTS:
      return mergeStates(state, { ...action.payload, contractsReqState: ReqState.SUCCESS });
    
    case Actions.STORE_SELECTED_INQUIRY:
      return mergeStates(state, { selectedInquiry: action.payload.selectedInquiry });

    // Modals and attachments
    case Actions.SHOW_MODAL:
      return mergeStates(state, action.payload);
    case Actions.HIDE_MODAL:
      return mergeStates(state, {
        visibleModal: null,
        documentForEditing: null,
        selectedVlKey: null
      });
    default:
      return state;
  }
}
